<template>
  <div>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-img 
            :alt="platformName"  
            contain 
            height="48px" 
            :src="require('@/assets/icons/unl.png')">
          </v-img>

          <h3 class="headline text-center pt-2">
            {{ platformName }}
          </h3>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text>
      <p>Inicie sesión con su correo electrónico y contraseña:</p>
      <v-form>
        <v-text-field
          outline
          label="Correo electrónico"
          type="text"
          @keyup.enter="login()"
          v-model="email">
        </v-text-field>
        <v-text-field
          outline
          hide-details
          label="Contraseña"
          type="password"
          @keyup.enter="login()"
          v-model="password">
        </v-text-field>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
      <v-row>
        
        <v-col cols="12" class="d-flex justify-end">
            <v-btn 
            color="info" 
            block
            :large="$vuetify.breakpoint.smAndUp" 
            :loading="loading" 
            @click="login">
            <v-icon left>lock</v-icon>
            Iniciar sesión
          </v-btn>
        </v-col>

        <v-col cols="12">
          <v-btn 
            small :to="{ name:'PasswordRecovery'}" 
            block 
            outlined 
            color="primary">
            ¿Olvidaste tu contraseña?
          </v-btn>
        </v-col>

      </v-row>
    </v-card-actions>

    <v-snackbar
      max-width="320"
      v-model="snackbar"
      :vertical="true"
      class="pb-4"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoginComponent',
  props: {
    source: String,
  },
  data: () => ({
    loading:false,
    snackbar:false,
    text:'',
    darkTheme: true,
    platformName:'JIJE',
    email:'',
    password: '',
    emailRules: [ 
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
    ]
  }),
  computed: {
  ...mapGetters([
    'isLogged', 'user'
    ])
  },
  methods: {
    login() {
      this.loading=true
      this.$store
      .dispatch('login', {
        email: this.email,
        password: this.password
      })
      .then(() => {
        this.$router.push({ name: 'CheckConvocations' })   
        this.loading=false
      })
      .catch((err) => {
        console.log(err)
        this.loading=false
        this.snackbar = true
        this.text = 'Correo eletrónico y/ó contraseña no valido.'
      })
    },

    cheakIsLogin(){
      if(this.isLogged){
        this.$router.push({ name: 'CheckConvocations' })
      }
    },
  },
  created(){
    this.cheakIsLogin();
  }
  }
</script>